import Timeline from '../components/Timeline';
import LightboxGallery from '../components/LightboxGallery';
import Slider from 'react-slick';
import '../css/weddingPage.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import foto1 from '../images/aniversario1.png';
import foto2 from '../images/aniversario2.png';
import foto3 from '../images/aniversario3.png';
import foto4 from '../images/aniversario4.png';

export default function DiaDosNamorados() {
  const fotos = [
    foto1, foto2, foto3, foto4
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false,
  };

  return (
    <>
      <section className="story-section">
        <Timeline
          events={[
            { date: '', title: 'No dia 28 de fevereiro, eu celebro meus 15 anos, um momento muito especial da minha vida. São 15 anos de histórias, aprendizados e sonhos que me trouxeram até aqui.' },
            { date: '', title: 'Sou apaixonada por livros, adoro mergulhar em histórias e deixar a imaginação viajar. Tenho um lado romântico, acredito nos sentimentos verdadeiros e valorizo muito as amizades, sendo sempre fiel a quem caminha ao meu lado.' },
            { date: '', title: 'Este novo ciclo marca o começo de uma fase cheia de descobertas, sonhos e conquistas. Que meus 15 anos sejam vividos com alegria, amor e muitas histórias bonitas para contar.' },
            { date: '', title: 'Sejam todos bem-vindos para celebrar esse momento comigo.'}
          ]}
        />
      </section>

      <section className="gallery-section">
        <h2>Minha memórias</h2>
        <Slider {...settings}>
          {fotos.map((src, i) => (
            <div key={i} className="slider-img-w">
              <img src={src} alt={`Foto ${i + 1}`} className="slider-img" />
            </div>
          ))}
        </Slider>
        <LightboxGallery images={fotos} className="" />
      </section>
    </>
  );
}
